<template>
  <div class="authWrapper">
    <div class="container d-flex justify-content-center">
      <div class="row login-wrap smart-login-wrap">
        <div class="col-lg-7 col-md-7" v-if="showSpinnerLoader">
          <spinners-loader />
        </div>
        <div class="col-lg-7 col-md-7" v-else>
          <div class="login-left-wrap">
            <div class="back-icon text-start">
              <router-link to="/login" class="ms-0">Back</router-link>
            </div>
            <div class="rep-icon-login">
                <img src="../../../assets/images/group-icon.svg" alt="">
            </div>
            <h4 class="mb-0"><b>Login with QR</b></h4>
            <div class="auth-form-wrap login-qr">
              <div>
                <div class="qr-image-container">
                  <img :src="QRUrl" class="mb-1" v-if="QRUrl" />
                </div>
                <div class="overlay" v-if="!isQrCodeValid">
                  <div class="retry-wrap" @click="regenerateQRCode">
                    <img
                      src="../../../assets/images/regenerate.svg"
                    />Regenerate <br />
                    QR Code
                  </div>
                </div>
                <div v-else>
                  <OTPTimer
                    title=""
                    @sendOTP="getQR"
                    @updateRemainingSecond="updateRemainingSecond"
                    :expirySecond="180"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md- no-padding">
          <div class="left-bg-smart rep-dash-bg">
            <div class="">
              <!-- <div class="bg-wrap"></div> -->
              <img
                src="../../../assets/images/mobile-ss.png"
                class="mobile-screen"
              />
            </div>
            <div class="qr-login-list">
            <h4>Use Group Dashboard:</h4>
            <ul>
              <li>Open Group App on your phone</li>
              <li>
                Tap QR Menu
                <img
                  src="../../../assets/images/qr-icon.svg"
                  alt="qr icon"
                  class="me-2 ms-2 qr-icon-bg"
                />
                located on top right of Group App
              </li>
              <li>Point your phone to this screen to capture the QR code.</li>
            </ul>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import helper from "@/resource/Helper";
import store from "@/store";
// import OTPTimer from "../../../components/ui/OTPTimer.vue";
import OTPTimer from "../../../components/ui/QROTPTimer.vue";
import SpinnersLoader from "../../../components/ui/SpinnerLoader.vue";
export default {
  name: "SmartLogin",
  components: {
    SpinnersLoader,
    OTPTimer,
  },
  data() {
    return {
      form: {
        username: "",
        password: "",
        deviceID: "",
      },
      loginLoader: false,
      formErrorFlag: false,
      formErrors: [],
      QRUrl: "",
      socket: null,
      message: "",
      messages: [],
      isQrCodeValid: false,
      showSpinnerLoader: false,
    };
  },
  mounted() {
    let deviceID = this.$store.getters.deviceId
      ? this.$store.getters.deviceId
      : this.$uuid.v1();
    let uniqueID = this.$uuid.v1();
    this.$store.commit("setDeviceId", deviceID);
    this.$store.commit("setUniqueID", uniqueID);
    this.getQR(this.$store.getters.uniqueID, this.$store.getters.deviceId);
    this.setupWebSocket();
  },
  methods: {
    getQR(code, deviceID) {
      this.showSpinnerLoader = true;
      this.isQrCodeValid = false;
      axios
        .get(
          `${process.env.VUE_APP_API_BASE_URL}/api.group/v1/auth/get-user-login-sync?unique_auth_id=${code}&device_id=${deviceID}`
        )
        .then((res) => {
          this.QRUrl = res.data.data.url;
          this.isQrCodeValid = true;
        })
        .catch((error) => {
          if (
            error.response &&
            error.response.data &&
            error.response.data.status === "error"
          ) {
            this.isQrCodeValid = false;
            let app = this;
            helper.infoMessage(
              app,
              error.response.data.status,
              error.response.data.message
            );
          }
        })
        .finally(() => {
          this.showSpinnerLoader = false;
        });
    },
    updateRemainingSecond(value) {
      let app = this;
      let remaningSecond = value;
      remaningSecond <= 0 && (app.isQrCodeValid = false);
    },
    regenerateQRCode() {
      let app = this;
      app.getQR(this.$store.getters.uniqueID, this.$store.getters.deviceId);
    },
    runPoll() {
      this.checkGroupAuthentication(
        this.$store.getters.uniqueID,
        this.$store.getters.deviceId
      );
    },

    setupWebSocket() {
      this.socket = new WebSocket(
        `${process.env.VUE_APP_WEB_SOCKET_URL}?device_id=${this.$store.getters.deviceId}`
      );
      this.socket.onopen = () => {
        console.log("WebSocket connection opened");
      };
      this.socket.onmessage = (event) => {
        const data = JSON.parse(event.data);
        if (data.event_type == "qr-login" && data.status == "success") {
          this.runPoll();
        }
      };
      this.socket.onclose = () => {
        console.log("WebSocket connection closed");
      };
    },
    checkGroupAuthentication: async (uniqueID, deviceID) => {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/api.group/v1/auth/check-login-authentication?unique_auth_id=${uniqueID}&device_id=${deviceID}`
        );
        if (response.data.status) {
          store.commit("setAuthentication", true);
          store.commit("setMainGroupId", response.data.group.group_id);
          store.commit("setGroupEmail", response.data.user.email);
          helper.setLoginDetails(response.data);
          helper.dashboardGetters();
        }
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.status === "error"
        ) {
          let app = this;
          helper.infoMessage(
            app,
            error.response.data.status,
            error.response.data.message
          );
        }
      }
    },
  },
};
</script>

<style src="../../../assets/css/smart-login.css"></style>